import React from "react";

const UPDATED_AT = "4 juillet 2026";
const CONTACT_EMAIL = "unlimitedsession@gmail.com";

const legalIdentity = [
  ["Éditeur du site", "Unlimited Session"],
  ["Activité", "Label musical, studio d'enregistrement, services audio, création artistique et espace de commande Latdior."],
  ["Email de contact", CONTACT_EMAIL],
  ["Forme juridique", "À compléter avec la structure exacte de l'éditeur."],
  ["SIRET / RCS", "À compléter si l'activité est immatriculée."],
  ["Adresse du siège", "À compléter avec l'adresse officielle de l'éditeur."],
  ["Directeur de publication", "À compléter avec le représentant légal ou responsable éditorial."],
  ["Hébergement", "Firebase Hosting, service Google Cloud. Google Cloud EMEA Limited, 70 Sir John Rogerson's Quay, Dublin 2, Irlande."],
];

const pages = {
  legal: {
    eyebrow: "Cadre légal",
    title: "Mentions légales",
    intro:
      "Cette page rassemble les informations d'identification du site Unlimited Session. Les champs marqués à compléter doivent être renseignés avec tes informations officielles pour que la page soit totalement finalisée.",
    sections: [
      {
        title: "Identification",
        rows: legalIdentity,
      },
      {
        title: "Responsabilité éditoriale",
        paragraphs: [
          "Unlimited Session édite un site consacré à la musique, aux artistes, au studio, aux services audio et aux capsules Latdior présentées sur le site.",
          "Les informations publiées sont fournies avec soin. Elles peuvent toutefois évoluer, notamment les tarifs, disponibilités, statuts de réservation, liens externes et contenus artistiques.",
        ],
      },
      {
        title: "Propriété intellectuelle",
        paragraphs: [
          "Les logos, textes, photographies, vidéos, pochettes, sons, extraits, visuels, noms de projets, éléments graphiques et contenus artistiques diffusés sur le site sont protégés par le droit d'auteur, le droit des marques et les droits voisins lorsqu'ils s'appliquent.",
          "Toute reproduction, diffusion, extraction, adaptation, réutilisation commerciale ou mise en ligne d'un contenu Unlimited Session sans autorisation écrite préalable est interdite.",
        ],
      },
      {
        title: "Liens externes",
        paragraphs: [
          "Le site peut rediriger vers des plateformes tierces comme YouTube, Spotify, Instagram, Stripe, Latdior Paris ou d'autres services externes. Unlimited Session n'est pas responsable du contenu, des conditions ou du fonctionnement de ces plateformes.",
        ],
      },
      {
        title: "Signalement",
        paragraphs: [
          `Pour signaler une erreur, un contenu problématique ou une demande liée aux droits d'auteur, contacte l'équipe à ${CONTACT_EMAIL}.`,
        ],
      },
    ],
  },
  privacy: {
    eyebrow: "RGPD",
    title: "Politique de confidentialité",
    intro:
      "Cette politique explique comment Unlimited Session traite les données personnelles collectées sur le site, conformément au RGPD et au droit français applicable.",
    sections: [
      {
        title: "Responsable de traitement",
        paragraphs: [
          `Le responsable de traitement est Unlimited Session. Pour toute demande liée aux données personnelles, écris à ${CONTACT_EMAIL}.`,
        ],
      },
      {
        title: "Données collectées",
        list: [
          "Compte utilisateur : email, nom affiché, identifiant Firebase, photo de profil si fournie par Google.",
          "Contact : nom, email, sujet et message.",
          "Newsletter et alertes disponibilité : email, produit concerné, date d'inscription et statut.",
          "Réservations et commandes : prestations choisies, créneaux, fichiers transmis, statut, montant, historique de commande.",
          "Données techniques : informations nécessaires au fonctionnement du site, de l'authentification, du panier et de la sécurité.",
        ],
      },
      {
        title: "Finalités et bases légales",
        list: [
          "Répondre aux messages et demandes de devis : intérêt légitime ou mesures précontractuelles.",
          "Créer et gérer un compte, une commande, une réservation ou un upload audio : exécution d'un contrat ou mesures précontractuelles.",
          "Envoyer une newsletter ou une alerte disponibilité : consentement.",
          "Sécuriser le site, éviter les abus et conserver l'historique admin : intérêt légitime.",
          "Respecter les obligations comptables ou légales lorsqu'elles s'appliquent : obligation légale.",
        ],
      },
      {
        title: "Destinataires et sous-traitants",
        paragraphs: [
          "Les données sont accessibles uniquement aux personnes habilitées côté Unlimited Session et aux prestataires techniques nécessaires au fonctionnement du site.",
        ],
        list: [
          "Firebase / Google Cloud pour l'hébergement, l'authentification, Firestore, Storage et Functions.",
          "Resend pour l'envoi des emails automatiques.",
          "Stripe si le paiement en ligne est activé.",
          "Les plateformes externes ouvertes volontairement par l'utilisateur, par exemple YouTube, Spotify ou Latdior Paris.",
        ],
      },
      {
        title: "Durées de conservation",
        list: [
          "Messages contact : jusqu'à 3 ans après le dernier échange utile.",
          "Newsletter et alertes : jusqu'au désabonnement, au retrait du consentement ou à la fin de l'alerte.",
          "Compte utilisateur : pendant la durée d'utilisation du compte, puis suppression ou anonymisation sur demande légitime.",
          "Commandes et éléments de facturation : durée nécessaire à la gestion commerciale et aux obligations comptables applicables.",
          "Fichiers audio transmis pour un service : durée nécessaire au traitement de la commande, sauf accord différent.",
        ],
      },
      {
        title: "Tes droits",
        paragraphs: [
          "Tu peux demander l'accès, la rectification, l'effacement, la limitation, l'opposition, la portabilité de tes données ou retirer ton consentement lorsque le traitement repose sur celui-ci.",
          `Pour exercer tes droits, écris à ${CONTACT_EMAIL}. Tu peux aussi déposer une réclamation auprès de la CNIL si tu estimes que tes droits ne sont pas respectés.`,
        ],
      },
      {
        title: "Cookies et traceurs",
        paragraphs: [
          "Le site peut utiliser des éléments techniques indispensables au fonctionnement de la connexion, du panier, de l'administration et de la sécurité. Si des cookies de mesure d'audience, publicité ou marketing sont ajoutés, ils devront être soumis à consentement lorsque la loi l'exige.",
        ],
      },
    ],
  },
  terms: {
    eyebrow: "Conditions",
    title: "Conditions générales",
    intro:
      "Ces conditions encadrent l'utilisation du site Unlimited Session, les demandes de studio, les services audio, les commandes Latdior et les échanges avec le label.",
    sections: [
      {
        title: "Accès au site",
        paragraphs: [
          "Le site présente l'univers Unlimited Session, ses artistes, actualités, services, contenus audiovisuels, réservations studio et produits Latdior disponibles ou à venir.",
          "L'accès peut être suspendu temporairement pour maintenance, sécurité, mise à jour ou décision éditoriale.",
        ],
      },
      {
        title: "Compte utilisateur",
        paragraphs: [
          "Certaines actions, comme réserver, commander ou acheter, peuvent nécessiter un compte utilisateur. L'utilisateur doit fournir des informations exactes et garder l'accès à son compte confidentiel.",
        ],
      },
      {
        title: "Réservations studio",
        list: [
          "Les demandes de réservation sont soumises à validation admin.",
          "Un créneau en attente peut bloquer temporairement la disponibilité afin d'éviter les doublons.",
          "Unlimited Session peut confirmer, refuser, annuler ou proposer un autre créneau en fonction de l'organisation du studio.",
          "Les tarifs affichés peuvent être modifiés depuis l'administration du site.",
        ],
      },
      {
        title: "Services audio",
        paragraphs: [
          "Les services de mixage, mastering, production ou accompagnement artistique sont traités selon les informations fournies par le client et les fichiers transmis.",
          "L'utilisateur garantit détenir les droits nécessaires sur les fichiers, voix, samples, instrumentales, textes, visuels ou références envoyés à Unlimited Session.",
        ],
      },
      {
        title: "Commandes Latdior",
        list: [
          "Les produits affichés peuvent être disponibles, indisponibles ou reliés à une alerte de disponibilité.",
          "Un produit indisponible reste visible mais ne peut pas être acheté tant qu'il n'est pas réactivé.",
          "Les liens vers latdiorparis.com permettent d'accéder au site officiel Latdior pour les autres collections ou informations de marque.",
        ],
      },
      {
        title: "Prix, paiement et validation",
        paragraphs: [
          "Les prix sont affichés en euros. Les paiements en ligne peuvent être opérés par Stripe lorsque la fonctionnalité est activée.",
          "Une commande ou une réservation peut rester en attente tant qu'elle n'a pas été validée, payée ou confirmée par l'administration.",
        ],
      },
      {
        title: "Droit de rétractation et annulation",
        paragraphs: [
          "Pour les ventes à des consommateurs, les règles françaises relatives au droit de rétractation s'appliquent lorsqu'aucune exception légale ne s'y oppose. Certains services personnalisés, contenus numériques ou prestations commencées avec accord du client peuvent être soumis à des règles particulières.",
          "Les conditions précises d'annulation, retour, remboursement et médiation devront être complétées selon la structure juridique et les modalités commerciales définitives d'Unlimited Session.",
        ],
      },
      {
        title: "Conduite et contenus transmis",
        paragraphs: [
          "L'utilisateur s'engage à ne pas transmettre de contenu illicite, injurieux, diffamatoire, contrefaisant, malveillant ou contraire aux droits de tiers. Unlimited Session peut refuser une demande ou une commande en cas de doute sérieux.",
        ],
      },
      {
        title: "Médiation",
        paragraphs: [
          "Si Unlimited Session vend à des consommateurs, un médiateur de la consommation devra être désigné et indiqué ici avec ses coordonnées complètes.",
        ],
      },
    ],
  },
};

function InfoRows({ rows = [] }) {
  return (
    <div className="grid grid-cols-1 overflow-hidden rounded-lg border border-white/10 md:grid-cols-2">
      {rows.map(([label, value]) => (
        <div key={label} className="border-b border-white/10 bg-black p-4 last:border-b-0 md:border-r md:even:border-r-0">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-red-400">{label}</p>
          <p className="readable-copy mt-2 text-sm text-gray-200">{value}</p>
        </div>
      ))}
    </div>
  );
}

function Section({ section }) {
  return (
    <section className="rounded-lg border border-white/10 bg-zinc-950 p-6 md:p-8">
      <h2 className="text-2xl font-black uppercase">{section.title}</h2>
      {section.rows && <div className="mt-5"><InfoRows rows={section.rows} /></div>}
      {section.paragraphs?.map((paragraph) => (
        <p key={paragraph} className="readable-copy mt-4 text-gray-300">
          {paragraph}
        </p>
      ))}
      {section.list && (
        <ul className="mt-5 space-y-3">
          {section.list.map((item) => (
            <li key={item} className="readable-copy rounded border border-white/10 bg-black px-4 py-3 text-sm text-gray-300">
              {item}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export default function LegalPage({ title, type = "legal" }) {
  const page = pages[type] || pages.legal;

  return (
    <main className="min-h-screen bg-black px-6 py-24 text-white md:px-20">
      <section className="mx-auto max-w-5xl">
        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.25em] text-red-500">
          {page.eyebrow}
        </p>
        <h1 className="text-4xl font-black uppercase md:text-6xl">{title || page.title}</h1>
        <p className="readable-copy mt-6 max-w-3xl text-lg text-gray-300">{page.intro}</p>
        <p className="mt-4 text-sm font-bold uppercase tracking-[0.18em] text-gray-500">
          Dernière mise à jour : {UPDATED_AT}
        </p>

        {type === "legal" && (
          <div className="mt-10 rounded-lg border border-red-500/30 bg-red-950/20 p-5">
            <p className="text-sm font-bold uppercase tracking-[0.16em] text-red-200">
              À compléter pour une conformité totale
            </p>
            <p className="readable-copy mt-3 text-sm text-red-50/80">
              Les mentions légales françaises demandent l'identification précise de l'éditeur.
              Ajoute ta forme juridique, ton SIRET/RCS, ton adresse officielle et le directeur
              de publication dès que ces informations sont confirmées.
            </p>
          </div>
        )}

        <div className="mt-10 space-y-6">
          {page.sections.map((section) => (
            <Section key={section.title} section={section} />
          ))}
        </div>

        <div className="mt-10 rounded-lg border border-white/10 bg-zinc-950 p-6">
          <p className="readable-copy text-gray-300">
            Pour toute question liée à ces pages, contacte Unlimited Session à{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} className="font-bold text-white underline decoration-red-500 underline-offset-4">
              {CONTACT_EMAIL}
            </a>.
          </p>
        </div>
      </section>
    </main>
  );
}
